export const REDIRECT_TO_PAGES = ['purchase-offer', 'checkout-media'];
